"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ImageUpload = require("../elements/ImageUpload");

var _ImageUpload2 = _interopRequireDefault(_ImageUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["employeeFirstname", "goalPictureUrl", "originPicture"],
  data: function data() {
    return {
      uploadImageText: null,
      imageSrc: this.goalPictureUrl,
      timestamp: Date.now()
    };
  },

  components: {
    ImageUpload: _ImageUpload2.default
  },
  mounted: function mounted() {
    this.uploadImageText = this.originPicture ? this.$t("dashboard.buttons.change_goal_picture") : this.$t("dashboard.buttons.upload_goal_picture");
  },


  methods: {
    imageUploaded: function imageUploaded(res) {
      this.imageSrc = "/goalpictures/" + res.goal_picture;
      this.timestamp = Date.now();
      this.$toastr.success(this.$t("common.messages.image_updated"));
    },
    errorHandler: function errorHandler(error) {
      // Expecting only large file errors.
      this.$toastr.error(this.$t("common.messages.large_image_error"));
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/dashboard/WelcomeBlock.vue
// module id = zBr4
// module chunks = 1